import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
// eslint-disable-next-line import/no-unresolved
import _ from 'lodash';
import React, { useCallback } from 'react';
import { useTranslator } from '@jutro/locale';
import { withRouter } from 'react-router-dom';
import messages from './RenewalConfirmation.messages';
import metadata from './RenewalConfirmation.metadata.json5';
import styles from './RenewalConfirmation.module.scss';
import { Link } from '@jutro/router';

function RenewalConfirmation(props) {
    const { location, history } = props;
    const submissionVM = location.state.response;
    const policyNumber = _.get(submissionVM, 'policyNumber');
    const referenceNumber = _.get(submissionVM, 'jobID');
    const translator = useTranslator();

    const getUrlAndOpen = useCallback(() => {
        const redirectPath = `/policies/${policyNumber}/billing`;
        
        history.push(redirectPath);
    }, [history, policyNumber]);

    const getBillingText = useCallback(() => (
        <span>
            {translator(messages.billingMessage)}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, react/jsx-no-literals */}
            <Link onClick={() => { getUrlAndOpen() }}>
            Policy Billing Page
            {/* eslint-disable-next-line react/jsx-no-literals */}
            </Link>.
        </span>
    ), [getUrlAndOpen, translator]);

    const getPolicyNumber = useCallback(() => (
        <span>
            {`${_.get(submissionVM, 'baseData.productName')} Policy: ${policyNumber}`}
        </span>
    ), [policyNumber, submissionVM]);

    const getReferenceNumber = useCallback(() => (
        <span>
            {`Reference Number: ${referenceNumber}`}
        </span>
    ), [referenceNumber]);
   
    const overrideProps = {
        policyNumber: {
            content: getPolicyNumber()
        },
        billingPageMessage: {
            content: getBillingText()
        },
        referenceNumber: {
            content: getReferenceNumber()
        }
    };

    const goToPolicy = useCallback(() => {
        const redirectPath = `/policies/${policyNumber}/summary`;

        history.push(redirectPath);
    }, [history, policyNumber]);

    const goToRenewalDetails = useCallback(() => {
        const redirectPath = `/renewal/${referenceNumber}/summary`;

        history.push(redirectPath);
    }, [history, referenceNumber]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            goToPolicy,
            goToRenewalDetails
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

RenewalConfirmation.propTypes = wizardProps;
export default withRouter(RenewalConfirmation);
